import PacketCardController from '../../../components/packet-card/packet-card.controller';
import PackageService from '../../../common/services/package/package.service';
import PriceService from '../../../common/services/price.service';

/**
 * OTP ile dogrulanmis akisin paket karti.
 *
 * Girisli kartin tamamini devralir; promokod calculate gorunumu, trial
 * satirlari ve yesil bilgi kutusu iki akista birebir ayni calissin diye
 * mantik burada tekrarlanmaz. Yalnizca iki fark override edilir:
 *   - getInfo: oturum gerektiren listeningpackage/list/v2 cagrisi yapilmaz,
 *     paket zaten binding ile geliyor.
 *   - getIcon: paket henuz baglanmadan cagrilabildigi icin null korumali.
 */
/* @ngInject */
export default class NoAuthPacketCardController extends PacketCardController {
  constructor(
    packageService: PackageService,
    $sce,
    $translate,
    $rootScope,
    priceService: PriceService,
    i18n
  ) {
    super(packageService, $sce, $translate, $rootScope, priceService, {}, i18n);
  }

  public getInfo() {
    try {
      this.timePeriod = this.priceService.getPriceInfo(this.packet);

      this.priceDetails = JSON.parse(this.packet.priceDescription);
      this.priceDetails.priceUnit = 'TL';
      this.priceDetails.basePrice = this.packet.basePrice;

      const translation = this.$translate.instant(this.timePeriod);
      this.priceDetails.time = this.$sce.valueOf(translation);
    } catch (error) {
      // priceDescription bozuk JSON olabilir; kart fiyat satirlarisiz cizilir.
    }
  }

  public getIcon() {
    if (!this.packet) {
      return undefined;
    }

    return this.packageService.getPackageIcon(this.packet);
  }
}



// WEBPACK FOOTER //
// ./src/app/no-auth/components/packet-card/packet-card.controller.ts